import validator from 'validatorjs';

const equal = (text: string, other: string): boolean => {
  return text === other;
};

validator.register('equal', equal, 'O e-mail digitado precisa ser idêntico ao anterior');
